/**
 * useRequestMarketState hook (ST5)
 *
 * Fetches the org-facing "Matches & gesicherte Angebote" state for a single
 * request from /api/tenant/requests/[id]/matches. Imports the type from the
 * types module (not the @/lib/requests barrel) to avoid pulling server-only
 * code into the client bundle.
 */

"use client";

import { useState, useEffect, useCallback } from "react";
import type { OrgRequestMarketState } from "@/lib/requests/matches-types";
export function useRequestMarketState(requestId: string) {
  const [state, setState] = useState<OrgRequestMarketState | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const fetchState = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await fetch(`/api/tenant/requests/${requestId}/matches`);
      if (res.ok) {
        const json = await res.json();
        setState(json.data ?? null);
      }
    } catch {
      // non-fatal — the section just shows its empty state
    } finally {
      setIsLoading(false);
    }
  }, [requestId]);
  useEffect(() => {
    if (requestId) fetchState();
  }, [requestId, fetchState]);
  return {
    state,
    isLoading,
    refresh: fetchState
  };
}